import { FunctionComponent } from 'preact';
import { StateUpdater, useEffect, useLayoutEffect, useRef } from 'preact/hooks';
import { Container } from './HorizontalSlideCard.styles';
import { useIntersection } from './HorizontalSlideCard.hook';
import { FlippingCard } from '../FlippingCard';

interface HorizontalSlideCardProps {
  index: number;
  children: any;
  cardHeight: number | null;
  setCardHeight: StateUpdater<number | null>;
  consolidateVisibleItemIds?: (id: string, isVisible: boolean) => void;
  ariaHidden?: boolean;
  onFocus?: () => void;
}

// Should rename to GrowingCard ???
const HorizontalSlideCard: FunctionComponent<HorizontalSlideCardProps> = ({
  index,
  children = FlippingCard,
  cardHeight,
  setCardHeight,
  consolidateVisibleItemIds,
  ariaHidden,
  onFocus,
}) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const isVisible = useIntersection(cardRef);

  // avoid flickering when height is null
  useLayoutEffect(() => {
    const { height = null } = cardRef.current?.getBoundingClientRect();
    // assumption: all cards heights are the same, must change this when PO says so
    if (index === 0 && height !== cardHeight) {
      setCardHeight(height);
    }
  }, [index, cardHeight, setCardHeight]);

  useEffect(() => {
    consolidateVisibleItemIds(`pp_carousel_item_${index}`, isVisible);
  }, [isVisible, consolidateVisibleItemIds, index]);

  return (
    <Container
      data-testid={`pp_carousel_item_${index}`}
      id={`pp_carousel_item_${index}`}
      ref={cardRef}
      cardHeight={cardHeight}
      aria-hidden={ariaHidden}
      onFocusCapture={onFocus}
      data-card-container
    >
      {children}
    </Container>
  );
};

export { HorizontalSlideCard };
